export default "__VITE_ASSET__CvAaSk_H__"